import { render, staticRenderFns } from "./AutresInformations.vue?vue&type=template&id=12ca51b2"
import script from "./AutresInformations.vue?vue&type=script&lang=js"
export * from "./AutresInformations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports